import React from 'react';
import Page from '../Page';
import useScavenger from './useScavenger';
import { Button } from 'antd';
import useSetStep from './useSetStep';
import { css } from '@emotion/css';
import IntroClue from './IntroClue';
import { Step, StepOrder } from './types';
import SecondClue from './SecondClue';
import Title from './Title';
import ThirdClue from './ThirdClue';
import LuluClue from './LuluClue';
import VSClue from './VSClue';
import FinalClue from './FinalClue';
import SephoraClue from './SephoraClue';
import SaksClue from './SaksClue';
import SaksClueTwo from './SaksClueTwo';

const scavengerContainerClassName = css({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  maxWidth: 1000,
  gap: 16,
  padding: 32,

  img: {
    width: '100%',
  },
});

const Content: React.FC<{ curStep: Step }> = ({ curStep }) => {
  switch (curStep) {
    case 'Intro':
      return <IntroClue />;
    case 'Second':
      return <SecondClue />;
    case 'Third':
      return <ThirdClue />;
    case 'Lulu':
      return <LuluClue />;
    case 'VS':
      return <VSClue />;
    case 'Final':
      return <FinalClue />;
    case 'Sephora':
      return <SephoraClue />;
    case 'Saks':
      return <SaksClue />;
    case 'Saks2':
      return <SaksClueTwo />;
    default:
      return null;
  }
};

const ScavengerHuntPage: React.FC = () => {
  const scavenger = useScavenger();
  const { setStep } = useSetStep();

  if (scavenger.currentStep === StepOrder[StepOrder.length - 1]) {
    return (
      <Page backgroundColor='#fbdee2'>
        <div className={scavengerContainerClassName}>
          <Title title="Happy Valentine's Day Katie ❤️" />
          {StepOrder.map((step) => (
            <Content curStep={step} />
          ))}
        </div>
      </Page>
    );
  }

  return (
    <Page backgroundColor='#fbdee2'>
      <div className={scavengerContainerClassName}>
        <Title title="Happy Valentine's Day Katie ❤️" />
        {/* <Button
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
          }}
          onClick={() => setStep('Intro')}
        >
          Reset
        </Button> */}
        <Content curStep={scavenger.currentStep} />
      </div>
    </Page>
  );
};

export default ScavengerHuntPage;
